export default __webpack_public_path__ + "static/media/kat_duo.37928fcb.pdf";